import { Base } from '@studiometa/js-toolkit';

/**
 * Reveal the contact block matching the site selected in the claim form,
 * « reservation » branch.
 */
export default class ClaimFormRedirect extends Base {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'ClaimFormRedirect',
    refs: ['site[]'],
    options: {
      selectClass: {
        type: String,
        default: 'js-claim-sites',
      },
    },
  };

  /**
   * The sites dropdown, looked up in the parent form.
   * @returns {HTMLSelectElement | null}
   */
  get select() {
    return this.$el.closest('form')?.querySelector(`.${this.$options.selectClass} select`) ?? null;
  }

  /**
   * @returns {void}
   */
  mounted() {
    this.onSelectChange = () => this.update();
    this.select?.addEventListener('change', this.onSelectChange);
    this.update();
  }

  /**
   * @returns {void}
   */
  destroyed() {
    this.select?.removeEventListener('change', this.onSelectChange);
  }

  /**
   * Show the single block whose site matches the selected value.
   *
   * The whole message stays hidden until a site is picked: on its own, the
   * intro tells the user to contact a site without naming one.
   * @returns {void}
   */
  update() {
    const value = this.select?.value ?? '';
    const blocks = /** @type {HTMLElement[]} */ (this.$refs.site);

    this.$el.hidden = value === '';

    blocks.forEach((block) => {
      block.hidden = block.dataset.site !== value;
    });
  }
}
